module.exports = __webpack_public_path__ + "img/img14.5ee75949.svg";